import { render, staticRenderFns } from "./AgentDetailsSections.vue?vue&type=template&id=5a074dda"
import script from "./AgentDetailsSections.vue?vue&type=script&lang=js"
export * from "./AgentDetailsSections.vue?vue&type=script&lang=js"
import style0 from "./AgentDetailsSections.vue?vue&type=style&index=0&id=5a074dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports